<template>
    <div id="contenedor-configuracion-default"></div>
</template>

<script>
export default {
  name: 'ConfiguracionDefault',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
